import { nanoid } from 'nanoid';
import { useEffect, useState } from 'react';
import Button from '../../../components/bootstrap/Button';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../../components/bootstrap/Modal';

const SPLogin = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [amazonCallbackUri, setAmazonCallbackUri] = useState<string | null>(null);
	const [amazonState, setAmazonState] = useState<string | null>(null);
	const [sellingPartnerId, setSellingPartnerId] = useState<string | null>(null);

	const handleAcceptAuthorize = () => {
		const stateConfirmToken = nanoid();
		localStorage.setItem('stateConfirmToken', stateConfirmToken);
		const callbackUrl = `${amazonCallbackUri}?amazon_state=$${amazonState}&state=${stateConfirmToken}&version=beta`;
		window.location.replace(callbackUrl);
	};

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		setAmazonCallbackUri(urlParams.get('amazon_callback_uri'));
		setAmazonState(urlParams.get('amazon_state'));
		const partnerId = urlParams.get('selling_partner_id');
		setSellingPartnerId(partnerId);
		localStorage.setItem('sellingPartnerId', partnerId || '');

		setIsOpen(true);
	}, []);

	return (
		<Modal
			title='SPCallback'
			isOpen={isOpen}
			setIsOpen={setIsOpen}
			isAnimation={false}
			isStaticBackdrop>
			<ModalHeader>
				<ModalTitle id='auth-confirm'>
					OMS ProSeller wants to connect to your Amazon account
				</ModalTitle>
			</ModalHeader>
			<ModalBody>
				OMS ProSeller will be able to: View your order history, access profile info, and
				manage app-specific settings. You can revoke access anytime from your Amazon account
				settings. Proceed?
			</ModalBody>
			<ModalFooter>
				<Button icon='Check' color='success' onClick={() => handleAcceptAuthorize()}>
					Accept
				</Button>
			</ModalFooter>
		</Modal>
	);
};
export default SPLogin;
